import { Flex, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import S6Logo from '../../assets/S6_full_logo_dark.png';
import { BackIcon } from '../iconComponents/BackIcon';
import { HeaderMenu } from './HeaderMenu';
import { LoadingBar } from './LoadingBar';

interface BrowserTopBarProps {
    children?: React.ReactNode;
    color?: string;
    loadingColor?: string;
    isLoading: boolean;
}

export const BrowserTopBar: React.FC<BrowserTopBarProps> = ({
    children,
    color,
    loadingColor,
    isLoading,
}) => {
    const navigate = useNavigate();

    return (
        <Flex className={'browser-view-topbar'}>
            <Flex className={'browser-view-topbar-content'}>
                <Image className={'browser-view-logo'} src={S6Logo} />
                <Flex className={'browser-view-titlebar'}>
                    <Flex
                        className={'browser-view-back'}
                        onClick={() => navigate(-1)}
                        color={color ? color : '#000'}
                    >
                        <BackIcon />
                    </Flex>
                    {children}
                </Flex>
                <HeaderMenu />
            </Flex>
            <LoadingBar barColour={loadingColor || '#FFF'} isLoading={isLoading} />
        </Flex>
    );
};
